import React, { createContext, ReactNode, useContext } from 'react';
import { FlagState } from '../libs';
import { FLAG_SUP_FEATURES } from 'configs/featureFlags';

interface FeatureFlagProviderProps {
  children: ReactNode;
  flags?: FlagState;
}

interface FeatureFlagContextInterface {
  flags?: FlagState;
}

const FeatureFlagContext = createContext<FeatureFlagContextInterface>({});

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
  flags,
}: FeatureFlagProviderProps) => {
  flags = flags || FLAG_SUP_FEATURES;
  return (
    <FeatureFlagContext.Provider value={{ flags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => {
  return useContext(FeatureFlagContext);
};
